import React, { useState } from 'react';
import { countryCodes } from './countries';


const PhoneInputWithFlagDropdown = ({ onChange }) => {
  const [selectedCountry, setSelectedCountry] = useState(countryCodes[80]);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleSelectCountry = (country) => {
    setSelectedCountry(country);
    setDropdownOpen(false);
    handleChange(country.code, phoneNumber);
  };

  const handleChange = (code, number) => {
    onChange(`${code}${number}`);
  };

  return (
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', position: 'relative',zIndex:10 }}>
      {/* Bayrak ve dropdown */}
      <div style={{ position: 'relative' }}>
        <div
          onClick={() => setDropdownOpen(!dropdownOpen)}
          style={{
            // border: '1px solid #ccc',
            padding: '5px 10px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            // minWidth: '100px',
          }}
        >
          <img
            src={`https://flagcdn.com/w40/${selectedCountry.iso}.png`}
            alt="flag"
            style={{ width: '20px' }}
          />
          <span>{selectedCountry.code}</span>
        </div>

        {dropdownOpen && (
          <ul
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              zIndex: 100,
              background: '#fff',
              border: '1px solid #ccc',
            //   width: '100%',
              listStyle: 'none',
              margin: 0,
              padding: 0,
              maxHeight: '200px',
              overflowY: 'auto',
            }}
          >
            {countryCodes.map((country) => (
              <li
                key={country.code}
                onClick={() => handleSelectCountry(country)}
                style={{
                  padding: '6px 10px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  width:'max-content'
                }}
              >
                <img
                  src={`https://flagcdn.com/w40/${country.iso}.png`}
                  alt={country.name}
                  style={{ width: '20px' }}
                />
                <span>
                  {country.name} ({country.code})
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Telefon numarası */}
      <input
        type="tel"
        placeholder="Telefon numarası"
        value={phoneNumber}
        onChange={(e) => {
          setPhoneNumber(e.target.value);
          handleChange(selectedCountry.code, e.target.value);
        }}
        style={{ padding: '6px', flex: 1 }}
      />
    </div>
  );
};

export default PhoneInputWithFlagDropdown;
